export const ProductRenderingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width='32' height='32' rx='4' fill='#F5F5F5' />
    <path
      d='M21.4982 23H12.9982C11.7001 22.9997 10.4276 22.6384 9.32298 21.9565C8.21837 21.2746 7.32513 20.2989 6.74308 19.1386C6.16103 17.9783 5.9131 16.679 6.027 15.3858C6.1409 14.0927 6.61214 12.8567 7.38805 11.816C8.16397 10.7753 9.214 9.97079 10.4208 9.49249C11.6276 9.01418 12.9437 8.88087 14.2219 9.10747C15.5001 9.33406 16.6901 9.91162 17.6589 10.7756C18.6278 11.6396 19.3373 12.756 19.7082 14H21.4982C22.6917 14 23.8363 14.4741 24.6802 15.318C25.5241 16.1619 25.9982 17.3065 25.9982 18.5C25.9982 19.6935 25.5241 20.8381 24.6802 21.682C23.8363 22.5259 22.6917 23 21.4982 23Z'
      fill='#0F172A'
    />
  </svg>
)
